import {
    /** FETCH APPLICATION  */
    FETCH_GETAPPLICATION_FULFILLED,
    FETCH_GETAPPLICATION_REJECTED,
    FETCH_GETAPPLICATION_PENDING,
    RESET,
} from "../../actions/application/getApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_GETAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_GETAPPLICATION_FULFILLED:
            return {
                ...state,
                getApplication: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_GETAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};